// src/redux/questSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const BASE = process.env.REACT_APP_API_URL;

// Thunk to fetch all quests
export const fetchQuests = createAsyncThunk(
  'quests/fetchAll',
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.auth.user?.token;
    const res = await fetch(`${BASE}/api/quests`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : undefined
      }
    });
    const data = await res.json();
    if (!res.ok) return thunkAPI.rejectWithValue(data.error || 'Fetch quests failed');
    return data;
  }
);

const questSlice = createSlice({
  name: 'quests',
  initialState: {
    list:   [],
    status: 'idle',
    error:  null
  },
  extraReducers: builder => {
    builder
      .addCase(fetchQuests.pending,   state => { state.status='loading'; state.error=null })
      .addCase(fetchQuests.fulfilled, (state, {payload}) => {
        state.status = 'succeeded';
        state.list   = payload;
      })
      .addCase(fetchQuests.rejected,  (state, action) => {
        state.status = 'failed';
        state.error  = action.payload;
      });
  }
});

export default questSlice.reducer;